import { env } from '@/lib/env';
import type { User } from '@/types/user';

interface PersonalInfoFields {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
}

interface CaregiverTermsFields {
  caregiverTermsAcceptedAt?: string;
  caregiverTermsVersion?: string;
}

export function isPersonalInfoComplete(user: PersonalInfoFields | null | undefined): boolean {
  return Boolean(user?.firstName && user?.lastName && user?.phoneNumber);
}

export function hasAcceptedCurrentCaregiverTerms(
  user: CaregiverTermsFields | null | undefined,
  currentVersion: string
): boolean {
  if (!user?.caregiverTermsAcceptedAt) {
    return false;
  }

  return user.caregiverTermsVersion === currentVersion;
}

export function isOnboardingComplete(
  user: Pick<
    User,
    | 'firstName'
    | 'lastName'
    | 'phoneNumber'
    | 'caregiverTermsAcceptedAt'
    | 'caregiverTermsVersion'
  > | null | undefined,
  currentVersion: string = env.clientBookingTermsVersion
): boolean {
  return isPersonalInfoComplete(user) && hasAcceptedCurrentCaregiverTerms(user, currentVersion);
}
